import { ApolloClient, ApolloLink, InMemoryCache, split, HttpLink } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import config from 'src/config';
import { rateLimitErrorLink } from '../rateLimitErrorLink';

const httpUri = [config.REACT_APP_API_URL_ADDITIONAL, 'webshop'].join('/');
const wsUri = httpUri.replace(/^http/, 'ws');

const httpLink = new HttpLink({ uri: httpUri, credentials: 'include' });

/**
 * Latest browser WebSocket for the additional GraphQL WS client (null when idle/closed).
 * Used to detect dead connections and trigger an Apollo subscription `restart()`.
 */
export const additionalGraphqlWebSocketRef: { current: WebSocket | null } = { current: null };

export function isAdditionalGraphqlWsOpen(): boolean {
  const ws = additionalGraphqlWebSocketRef.current;
  return ws !== null && ws.readyState === WebSocket.OPEN;
}

const wsLink = new GraphQLWsLink(
  createClient({
    url: wsUri,
    connectionParams: () => ({}),
    on: {
      opened: (socket) => {
        additionalGraphqlWebSocketRef.current = socket as WebSocket;
      },
      closed: () => {
        additionalGraphqlWebSocketRef.current = null;
      },
    },
  })
);

const splitLink = split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return def.kind === 'OperationDefinition' && def.operation === 'subscription';
  },
  wsLink,
  httpLink
);

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        health: {
          merge(incoming, existing = {}) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
  },
});

const apolloClientAdditional = new ApolloClient({
  link: ApolloLink.from([rateLimitErrorLink, splitLink]),
  cache,
});

export default apolloClientAdditional;
